import { FormGroup, Validators } from "@angular/forms"
import { LayerType, overlayBlur, sharedForms } from "../layer.model"
import { BuildingProperties, FormType, Properties } from "../properties.model"
import { Subject } from "rxjs"
import { generateBuildingOptions } from "../../../services/image-data.utils"

export const buildingForm: Properties = {
  propertyType: LayerType.Buildings,
  label: 'Building Layer',
  forms:
    sharedForms.concat([
    {
      id: BuildingProperties.BuildingGroup,
      label: 'Building Group',
      type: FormType.Multiselect,
      hint: "These are defined in the RenderSettings ModuleScript within Roblox Studio.",
      placeholder: 'Building Groups',
    },
    {
      id: BuildingProperties.BuildingColor,
      label: 'Fill Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: BuildingProperties.BuildingColorOpacity,
      label: 'Fill Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    {
      id: BuildingProperties.BuildingWeatheredRoofs,
      label: 'Weathered Roofs',
      hint: "This is useful for creating color variation in the building, most useful on non white/black colors.",
      type: FormType.Checkbox,
      defaultValue: false
    },
    {
      id: BuildingProperties.BuildingWeatheredVariation,
      hint: "Control the amount of color variation on the buildings.",
      label: 'Weathered Roof Variation',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    overlayBlur
  ]),
  changeHandler: (fg: FormGroup, formChanged: Subject<void>) => {},
  onInit: (data ) => {
    const selector = buildingForm.forms.find(form => form.id === BuildingProperties.BuildingGroup)
    if (selector) {
      selector.options = generateBuildingOptions(data.stringEncodings)
      const intitalOption = selector.options.find(option => option.value === 1)
      if (intitalOption) {
        selector.defaultValue = [intitalOption]
      }
    }
  }
}
